<template>
    <div>
        <Header v-bind:title="'住院记录'" v-bind:back="true"></Header>
        <van-tabs v-model="active" swipeable sticky color="#26a2ff">
            <van-tab title="住院信息">
                <van-cell-group>
                    <van-cell title="住院编号" :value="row.jzlsh" />
                    <van-cell title="患者姓名" :value="row.hzxm" />
                    <van-cell title="入院日期" :value="row.ryrq" />
                    <van-cell title="出院日期" :value="row.cyrq" />
                    <van-cell title="科室名称" :value="row.ksmc" />
                    <van-cell title="医生姓名" :value="row.ysmc" />
                    <van-cell title="手术名称" :value="row.ssmc" />
                    <van-cell title="费用（元）" :value="row.fyje" />
                </van-cell-group>
                <van-cell-group title="入院诊断">
                    <van-cell :value="row.ryzd" />
                </van-cell-group>
                <van-cell-group title="出院诊断">
                    <van-cell :value="row.cyzd" />
                </van-cell-group>
            </van-tab>
            <van-tab title="费用明细">
                <van-list
                        v-model="fymx.loading"
                        :finished="fymx.finished"
                        :finished-text="fymx.list.length > 0 ? '已全部加载' : '无费用记录'"
                        @load="getFymx()">
                    <van-cell-group v-for="(item,index) in fymx.list" :key="item.jzlsh">
                        <van-cell center :title="item.fyxm">
                            <template slot="label">
                                <span>日期：{{item.sfrq}}</span><br>
                                <span>单价：{{item.fydj}}元，数量：{{item.fysl}}，金额：{{item.fyje}}元</span>
                            </template>
                        </van-cell>
                    </van-cell-group>
                </van-list>
            </van-tab>
            <van-tab title="检验记录">
                <van-list
                        v-model="jymx.loading"
                        :finished="jymx.finished"
                        :finished-text="jymx.list.length > 0 ? '已全部加载' : '无检验记录'"
                        @load="getJymx()">
                    <van-cell-group v-for="(item,index) in jymx.list" :key="item.jybgid">
                        <van-cell center :title="item.bgmc" :label="'日期：'+item.sqsj" is-link :to="'/m-jyjl/jyjl/xx/'+Base64.encodeURI(JSON.stringify(item))"/>
                    </van-cell-group>
                </van-list>
            </van-tab>
            <van-tab title="检查记录">
                <van-list
                        v-model="jcmx.loading"
                        :finished="jcmx.finished"
                        :finished-text="jcmx.list.length > 0 ? '已全部加载' : '无检查记录'"
                        @load="getJcmx()">
                    <van-cell-group v-for="(item,index) in jcmx.list" :key="index">
                        <van-cell center :title="item.jcxm">
                            <template slot="label">
                                <span><span style="color:#393939">日期：</span>{{item.jcrq ? item.jcrq : '-'}}</span><br>
                                <span><span style="color:#393939">检查表现：</span>{{item.yxbx ? item.yxbx : '-'}}</span><br>
                                <span><span style="color:#393939">检查诊断：</span>{{item.yxzd ? item.yxzd : '-'}}</span>
                            </template>
                        </van-cell>
                    </van-cell-group>
                </van-list>
            </van-tab>
            <van-tab title="药品医嘱">
                <van-list
                        v-model="ypmx.loading"
                        :finished="ypmx.finished"
                        :finished-text="ypmx.list.length > 0 ? '已全部加载' : '无药品记录'"
                        @load="getYpmx()">
                    <van-cell-group v-for="(item,index) in ypmx.list" :key="item.cfh">
                        <van-cell center :title="item.ypmc" is-link @click="showInfo(item)">
                            <template slot="label">
                                <span>药品规格：{{item.ypgg}}</span><br>
                                <span>服务剂量：{{item.fyjl}}，用药方法：{{item.yyff}}</span><br>
                            </template>
                        </van-cell>
                    </van-cell-group>
                </van-list>
            </van-tab>
        </van-tabs>
        <show-info ref="ShowInfo" v-bind:title="infoTitle" v-bind:list="infoList"></show-info>
    </div>
</template>
<script type="text/ecmascript-6">
    import Header from './components/Header.vue'
    import ShowInfo from './components/ShowInfo.vue'
    import {findFymxZy,findJyjlZy,findJcjl,findYpyz} from '@/api/biApi.js'
    let Base64 = require('js-base64').Base64;
    export default{
        name:'',
        components:{Header,ShowInfo},
        data(){
            return {
                Base64:Base64,
                active:'',
                infoTitle:'',
                infoList:[],
                row:{},
                fymx:{
                    loading:false,
                    finished:false,
                    page:0,
                    list:[],
                },
                jymx:{
                    loading:false,
                    finished:false,
                    page:0,
                    list:[],
                },
                jcmx:{
                    loading:false,
                    finished:false,
                    page:0,
                    list:[],
                },
                ypmx:{
                    loading:false,
                    finished:false,
                    page:0,
                    list:[],
                },
                pageSize:15,
            }
        },
        mounted(){
            this.row = this.$route.params.row ? JSON.parse(Base64.decode(this.$route.params.row)) : {}
        },
        methods:{
            getFymx(){
                this.fymx.page += 1
                findFymxZy({
                    "jzlsh":this.row.jzlsh,
                    "size":this.pageSize,
                    "page":this.fymx.page
                }).then(res=>{
                    if(res && res.list.length > 0){
                        res.list.map((val,index)=>{
                            this.fymx.list.push(val)
                        })
                    }
                    if(!res || res.list.length < 15 ){
                        this.fymx.finished = true;
                    }
                    this.fymx.loading = false;
                }).catch(err=>{
                    this.$toast('获取失败');
                    this.fymx.loading = false;
                    this.fymx.finished = true;
                })
            },
            getJymx(){
                this.jymx.page += 1
                findJyjlZy({
                    "jzlsh":this.row.jzlsh,
                    "size":this.pageSize,
                    "page":this.jymx.page
                }).then(res=>{
                    if(res && res.list.length > 0){
                        res.list.map((val,index)=>{
                            this.jymx.list.push(val)
                        })
                    }
                    if(!res || res.list.length < 15 ){
                        this.jymx.finished = true;
                    }
                    this.jymx.loading = false;
                }).catch(err=>{
                    this.$toast('获取失败');
                    this.jymx.loading = false;
                    this.jymx.finished = true;
                })
            },
            getJcmx(){
                this.jcmx.page += 1
                findJcjl({
                    "jzlsh":this.row.jzlsh,
                    "size":this.pageSize,
                    "page":this.jcmx.page
                }).then(res=>{
                    if(res && res.list.length > 0){
                        res.list.map((val,index)=>{
                            this.jcmx.list.push(val)
                        })
                    }
                    if(!res || res.list.length < 15 ){
                        this.jcmx.finished = true;
                    }
                    this.jcmx.loading = false;
                }).catch(err=>{
                    this.$toast('获取失败');
                    this.jcmx.loading = false;
                    this.jcmx.finished = true;
                })
            },
            getYpmx(){
                this.ypmx.page += 1
                findYpyz({
                    "jzlsh":this.row.jzlsh,
                    "size":this.pageSize,
                    "page":this.ypmx.page
                }).then(res=>{
                    if(res && res.list.length > 0){
                        res.list.map((val,index)=>{
                            this.ypmx.list.push(val)
                        })
                    }
                    if(!res || res.list.length < 15 ){
                        this.ypmx.finished = true;
                    }
                    this.ypmx.loading = false;
                }).catch(err=>{
                    this.$toast('获取失败');
                    this.ypmx.loading = false;
                    this.ypmx.finished = true;
                })
            },

            showInfo(row){
                this.infoTitle = '药品医嘱【'+row.ypmc+'】'
                this.infoList  = [
                    {title:'开始日期',value:row.ksrq},
                    {title:'结束日期',value:row.ksrq},
                    {title:'序号',value:row.xh},
                    {title:'组号',value:row.zh},
                    {title:'药品名称',value:row.ypmc},
                    {title:'药品规格',value:row.ypgg},
                    {title:'服用剂量',value:row.fyjl},
                    {title:'剂量单位',value:row.jldw},
                    {title:'频次',value:row.pc},
                    {title:'用药方法',value:row.yyff},
                    {title:'备注',value:row.bz},
                ];
                this.$refs.ShowInfo.show = true
            }
        }
    }
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/components/mobile/zyjl-xx.vue